import { render, staticRenderFns } from "./GoHome.vue?vue&type=template&id=956e8434&scoped=true&"
import script from "./GoHome.vue?vue&type=script&lang=js&"
export * from "./GoHome.vue?vue&type=script&lang=js&"
import style0 from "./GoHome.vue?vue&type=style&index=0&id=956e8434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956e8434",
  null
  
)

export default component.exports